export default __webpack_public_path__ + "static/media/website.8ce2dcfd.jpg";